import { Route } from '@angular/router';

/**
 * Depth-first search of a route table for the first navigable page the caller
 * may open. A page is navigable when it has no path params, is not the entry
 * route itself, and its own `data.module`/`data.resource` pass `canAccess`.
 * Returns path segments relative to the table, or null when none qualify.
 */
export function findFirstAccessiblePath(
  routes: Route[],
  canAccess: (module: string, resource: string) => boolean,
  parentSegments: string[] = [],
): string[] | null {
  for (const r of routes) {
    const path = r.path ?? '';
    if (path.includes(':') || path === '**') {
      continue;
    }
    const segments = path ? [...parentSegments, path] : parentSegments;
    const module = r.data?.['module'];
    const resource = r.data?.['resource'];
    if (r.children?.length) {
      const nested = findFirstAccessiblePath(r.children, canAccess, segments);
      if (nested) {
        return nested;
      }
    }
    if (segments.length > 0 && !r.redirectTo && module && resource && canAccess(module, resource)) {
      return segments;
    }
  }
  return null;
}
